import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dertofderts-region',
  templateUrl: './dertofderts-region.component.html'
})
export class DertOfDertsRegionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
